import * as React from "react"
import { Colors, Fonts } from "../../materials"
import {
  Box,
  LinkAnchor,
  Code,
  ButtonIcon,
  Input,
  List,
  ListItem,
} from "../../elements"

const Nav = props => (
  <Box
    as="nav"
    css={{
      ol: {
        listStyleType: "none",
        display: "flex",
        alignItems: "center",
        margin: 0,
        padding: 0,
      },
      li: {
        display: "flex",
        alignItems: "center",
      },
      span: {
        fontSize: 20,
        paddingLeft: 16,
        paddingRight: 16,
      },
      a: {
        color: Colors.oc.blue[9],
        fontWeight: Fonts.sansBold.weight,
      },
      "a[aria-current]": {
        color: Colors.oc.black,
        textDecoration: "none",
        pointerEvents: "none",
      },
    }}
    {...props}
  />
)

export const SnippetBreadcrumbsMarkup: React.FC<{}> = () => (
  <Box display="flex" flexWrap="wrap" bg={Colors.oc.gray[1]}>
    <Box
      width={[1, 1, 0.5]}
      py={[3]}
      display="flex"
      alignItems="center"
      justifyContent="center"
      aria-hidden="true"
    >
      <Nav aria-label="breadcrumbs">
        <ol>
          <li>
            <a href="#">Home</a>
            <span aria-hidden="true">→</span>
          </li>
          <li>
            <a href="#">Parent</a>
            <span aria-hidden="true">→</span>
          </li>
          <li>
            <a href="#" aria-current="location">
              Current
            </a>
          </li>
        </ol>
      </Nav>
    </Box>
    <Box width={[1, 1, 0.5]}>
      <Code
        codeString={`<nav aria-label="breadcrumbs">
  <ol>
    <li>
      <a href="/">
        Home
      </a>
      <span aria-hidden="true">→<span>
    </li>
    <li>
      <a href="/parent">
        Parent
      </a>
      <span aria-hidden="true">→<span>
    </li>
    <li>
      <a
        href="/parent/current"
        aria-current="location"
      >
        Current
      </a>
    </li>
  </ol>
</nav>`}
        language="html"
      />
    </Box>
  </Box>
)
